import { MultiSelectType } from "../../thor.enums";

export class MultipleSelectController {
    public static $inject: string[] = ["$mdMedia", "$scope", "multipleSelect"];

    // Binded
    public elem;
    public type: MultiSelectType;

    public isSelected: boolean;

    constructor(public $mdMedia: ng.material.IMedia, $scope: ng.IScope, private multipleSelect) {
        $scope.$watch(
            () => this.multipleSelect.elems.length,
            (current, previous) => {
                if (current !== previous) {
                    this.isSelected = this.multipleSelect.isSelected(this.elem.id);
                }
            }
        );
    }

    public $onInit() {
        this.isSelected = this.multipleSelect.isSelected(this.elem.id);
    }

    public toggle() {
        this.multipleSelect.toggle(this.elem, this.type);
        this.multipleSelect.evaluatePossibleActions();
    }
}
